import { ICommand, IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { STCConfigsModel } from '../models/stcconfigs_model';

angular
  .module('capability-ng-priority-feed')
  .service(
    'submitSelfAlertCommand',
    function submitSelfAlertCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      log: any,
      ngSTCConfigsModel: STCConfigsModel,
      getJwtTokenCommand: ICommand,
      appConfigModel: any
    ) {
      return defineCommandORM('submitSelfAlertCommand', function submitSelfAlertCommand(deferred, selfAlertFormData) {
        const campusUrl = appConfigModel.getConfigProperty(`core-campus_url`);
        const alertName = ngSTCConfigsModel.read().self_alert_label;
        if (_4.isEmpty(campusUrl)) {
          deferred.resolve();
        } else {
          getJwtTokenCommand().then((token: any) => {
            const alert_reason = _4.get(selfAlertFormData, 'alert_reason_ids', []);
            selfAlertFormData.alert_reason_ids = _4.isArray(alert_reason) ? alert_reason : [alert_reason];

            const enrollment = _4.get(selfAlertFormData, 'enrollment_ids', []);
            selfAlertFormData.enrollment_ids = _4.isArray(enrollment) ? enrollment : [enrollment];

            selfAlertFormData.comments = _4.get(selfAlertFormData, 'comments', '');

            const urlFormatted = `/api/v3/student_resources/alerts`;
            const config = {
              url: campusUrl + urlFormatted,
              method: 'POST',
              data: selfAlertFormData,
              headers: {
                Authorization: token.access_token,
                isCampusAPI: true
              }
            };

            $http(config)
              .then((response) => {
                log.user.success(
                  `Success! As a reminder, you can review all your submissions in the <hi-link ui-sref='my.reports'>My Docs</hi-link> section in the app. `
                );
                deferred.resolve();
              })
              .catch((e: any) => {
                log.user.issue(`Your ${alertName} failed to send. Sorry please try again.`);
                deferred.reject(e);
              });
          });
        }
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/commands/submit_self_alert_command.ts